const themes = {
  headingImg: null,
  light: {
    primary: "#088481",
    secondary: "#D5761C",
    success: "#dcedc8",
    error: "#FF5252",
    lighterSuccess: "#dcedc8",
    lighterError: "#ffcdd2",
    auxiliary01: "#0066CC",
    auxiliary02: "#FAD97A",
    cancelColor: "#212323",
    title: "#353737",
    toolbar: "#ffffff",
    toolbarText: "#8b8d8d",
    appBar: "#f5f5f5",
    appBarText: "#000000",
    label: "#7C7D7D",
    tableBorder: "#B4B4B4",
    confirmDelete: "#B4B4B4",
    subtitle: "#7C7D7D",
    homeFooterText: "#7C7D7D",
    tableHeaderText: "#4F5050",
    myProfileText: "#080A0A",
    cardBackground: "#f4f4f4",
    expansiveRowBackground: "#ffffff",
    anchorText: "#636464",
    homeQuickAccessFunctions: "#7C7D7D",
    homeQuickAccessFunctionsParentMenu: "#b4b4b4",
    cardText: "#000000",
    boldText: "#171919",
  },
  dark: {
    primary: "#088481",
    secondary: "#D5761C",
    success: "#dcedc8",
    error: "#FF5252",
    lighterSuccess: "#dcedc8",
    lighterError: "#ffcdd2",
    auxiliary01: "#0066CC",
    auxiliary02: "#FAD97A",
    cancelColor: "#212323",
    title: "#353737",
    label: "#7C7D7D",
    tableBorder: "#B4B4B4",
    toolbarText: "#ffffff",
    appBar: "#121212",
    appBarText: "#ffffff",
    confirmDelete: "#B4B4B4",
    subtitle: "#ffffff",
    toolbar: "#000000",
    homeFooterText: "#ffffff",
    tableHeaderText: "#ffffff",
    anchorText: "#ffffff",
    myProfileText: "#ffffff",
    cardBackground: "#1E1E1E",
    expansiveRowBackground: "#2B2D2D",
    homeQuickAccessFunctions: "#ffffff",
    homeQuickAccessFunctionsParentMenu: "#ffffff",
    cardText: "#ffffff",
    boldText: "#ffffff",
  },
};

export default themes;
